import React, { Fragment } from "react";
import { CentreCol, LeftCol, Row, Tab } from "../..";
import { Card } from "../../Card";
import { TabPane } from "../../Tab";
export const DetailPageContent = ({ tabs, children }) => {
    if (tabs)
        return (React.createElement(DetailPageTabContainer, { tabs: tabs }, children));
    return React.createElement(Fragment, null, children);
};
export const DetailPageTabContainer = ({ tabs, children, }) => {
    const handleOnChange = (eventKey) => {
        const item = tabs.items.filter((item) => item.name === eventKey)[0];
        tabs.onChange && tabs.onChange(item);
    };
    return (React.createElement(Tab.Container, { id: tabs.id, defaultTab: tabs.defaultTab, onChange: handleOnChange },
        React.createElement(Row, null,
            React.createElement(LeftCol, null,
                React.createElement(Card, { title: tabs.title },
                    React.createElement(Tab.Menu, { items: tabs.items, type: "stacked" }))),
            React.createElement(CentreCol, null,
                React.createElement(Tab.Content, null, children)))));
};
export const DetailPageTab = ({ children, name, }) => (React.createElement(TabPane, { name: name }, children));
export const AssistantPanel = ({ children }) => (React.createElement(Fragment, null, children));
